import React, { useContext } from 'react';
import { MFBeaconButton } from '../../Beacon/BeaconComponents';
import { CartContext } from '../../../context/CartContext/CartContext';
import selectFundsRibbon from '../../../images/select-funds-ribbon.svg';
import milistone from '../../../images/Summit-Circle.svg';
import unlockIcon from '../../../images/blue-unlock.svg';
import styles from './styles.css';
import { checkSummitIClassEligibility } from '../../../flows/shared/summit.utils';

const FundLaterFundContents = ({
  fundsWithCategories,
  rewardsAvailable = { closedFunds: false, iClassFunds: false },
  amount,
  displayAddMore = false,
  handleAddMoreFundsClick = () => {},
  readOnly = false
}) => {
  const cartState = useContext(CartContext);
  const {
    api: { removeFund, determineFundMinimum }
  } = cartState;

  return (
    <div className="fund-contents">
      {checkSummitIClassEligibility(amount, rewardsAvailable) && (
        <div className="iclass-funds-message-view">
          <img
            className="iclass-funds-message-img"
            src={milistone}
            alt="Select Fund Certified"
          />
          <span className="iclass-funds-message-content">
            You&apos;re eligible to invest in lower-cost I Class shares ($50,000
            fund minimum).
          </span>
        </div>
      )}
      {fundsWithCategories?.length ? (
        <div className="funds">
          {fundsWithCategories.map(fund => (
            <div className="fund-row" key={fund.ticker}>
              {readOnly || (
                <div className="remove-button">
                  <MFBeaconButton
                    id="fundLaterRemoveFundBtn"
                    data-name={`fundLaterRemoveFundBtn-${fund.ticker}`}
                    type="button"
                    noButtonMargin
                    className="override-beacon-button-padding"
                    onClick={() => removeFund(fund.ticker)}
                    variant="tertiary"
                    label="Remove"
                  />
                </div>
              )}
              <div className={`name${readOnly ? ' read-only' : ''}`}>
                {fund.unlockedFund && (
                  <img
                    className="allo-sf-ribbon-icon"
                    src={unlockIcon}
                    alt="Unlocked"
                  />
                )}
                {fund.selectFund && (
                  <img
                    className="allo-sf-ribbon-icon"
                    src={selectFundsRibbon}
                    alt="Select Fund Certified"
                  />
                )}

                {fund.name}
                <span className="ticker">({fund.ticker})</span>
              </div>
              <div role="alert" aria-atomic="true" className="fund-minimum">
                $ {determineFundMinimum(fund, rewardsAvailable, amount)} Minimum
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-funds-error">
          <div>
            You must select at least one mutual fund to open your account,
            additional mutual funds may be added later.
          </div>
        </div>
      )}

      {displayAddMore && (
        <div className="add-more-btn-container">
          <MFBeaconButton
            id="viewAllFunds"
            onClick={handleAddMoreFundsClick}
            className="override-beacon-button-padding"
            variant="tertiary"
            label="+ Add More Funds"
            type="button"
          />
        </div>
      )}

      <style jsx>{styles}</style>
    </div>
  );
};

FundLaterFundContents.defaultProps = {
  readOnly: false
};

export default FundLaterFundContents;
